import { render, staticRenderFns } from "./VendorProduct.vue?vue&type=template&id=8aadae36&scoped=true&"
import script from "./VendorProduct.vue?vue&type=script&lang=js&"
export * from "./VendorProduct.vue?vue&type=script&lang=js&"
import style0 from "./VendorProduct.vue?vue&type=style&index=0&id=8aadae36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aadae36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VTextField})
